import axios from 'axios'

import {
    CustomerExistsUrl,
    BusinessInformationsUrl,
    CheckPostalCodeUrl,
} from '../constants/IntegrationConstants'

function getAxiosInstance(baseURL, apiKey) {
    return axios.create({
        baseURL: baseURL,
        timeout: 20000,
        withCredentials: false,
        headers: { 'X-ApiKey': apiKey }
    })
}

export function checkBusinessId(id) {

    try {
        const instance = getAxiosInstance()

        return instance.get(CustomerExistsUrl + id)
    } catch (error) {
        console.log(error)
        return error
    }
}

export function getBusinessInformation(id, baseURL, apiKey) {
    try {
        const instance = getAxiosInstance(baseURL, apiKey)
        return instance.get(BusinessInformationsUrl + id)
    } catch (error) {
        console.log(error)
        return error
    }
}

export function checkValidPostalcodeArea(postalCode, baseURL, apiKey) {
    try {
        const instance = getAxiosInstance(baseURL, apiKey)
        return instance.get(CheckPostalCodeUrl + postalCode)
    } catch (error) {
        console.log(error)
        return error
    }
}
